module.exports = __webpack_public_path__ + "img/1480370692.f25af130.jpg";